import poRouterConfigs from '@/main/router-configs/poRouterConfigs'
import fsRouterConfigs from '@/main/router-configs/fsRouterConfigs'
import hcRouterConfigs from '@/main/router-configs/hcRouterConfigs'
import tsRouterConfigs from '@/main/router-configs/tsRouterConfigs'
import esRouterConfigs from '@/main/router-configs/esRouterConfigs'
import ptRouterConfigs from '@/main/router-configs/ptRouterConfigs'

const projectRoutes = {
  'prime-opinion': {
    dynamicCampaigns: poRouterConfigs.PO_DYNAMIC_CAMPAIGNS,
    emailsCampaigns: poRouterConfigs.PO_DYNAMIC_CAMPAIGNS_EMAILS,
    emailsCreateCampaigns: poRouterConfigs.PO_DYNAMIC_CAMPAIGNS_EMAILS_CREATE,
    emailsEditCampaigns: poRouterConfigs.PO_DYNAMIC_CAMPAIGNS_EMAILS_EDIT,
    emailsTranslationsEditCampaigns:
      poRouterConfigs.PO_DYNAMIC_CAMPAIGNS_EMAILS_TRANSLATIONS_EDIT,
    pushNotificationsCampaigns:
      poRouterConfigs.PO_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS,
    pushNotificationsCreateCampaigns:
      poRouterConfigs.PO_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_CREATE,
    pushNotificationsEditCampaigns:
      poRouterConfigs.PO_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_EDIT,
    pushNotificationsTranslationsEditCampaigns:
      poRouterConfigs.PO_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_TRANSLATIONS_EDIT
  },
  'five-surveys': {
    dynamicCampaigns: fsRouterConfigs.FS_DYNAMIC_CAMPAIGNS,
    emailsCampaigns: fsRouterConfigs.FS_DYNAMIC_CAMPAIGNS_EMAILS,
    emailsCreateCampaigns: fsRouterConfigs.FS_DYNAMIC_CAMPAIGNS_EMAILS_CREATE,
    emailsEditCampaigns: fsRouterConfigs.FS_DYNAMIC_CAMPAIGNS_EMAILS_EDIT,
    emailsTranslationsEditCampaigns:
      fsRouterConfigs.FS_DYNAMIC_CAMPAIGNS_EMAILS_TRANSLATIONS_EDIT,
    pushNotificationsCampaigns:
      fsRouterConfigs.FS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS,
    pushNotificationsCreateCampaigns:
      fsRouterConfigs.FS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_CREATE,
    pushNotificationsEditCampaigns:
      fsRouterConfigs.FS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_EDIT,
    pushNotificationsTranslationsEditCampaigns:
      fsRouterConfigs.FS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_TRANSLATIONS_EDIT
  },
  'hey-cash': {
    dynamicCampaigns: hcRouterConfigs.HC_DYNAMIC_CAMPAIGNS,
    emailsCampaigns: hcRouterConfigs.HC_DYNAMIC_CAMPAIGNS_EMAILS,
    emailsCreateCampaigns: hcRouterConfigs.HC_DYNAMIC_CAMPAIGNS_EMAILS_CREATE,
    emailsEditCampaigns: hcRouterConfigs.HC_DYNAMIC_CAMPAIGNS_EMAILS_EDIT,
    emailsTranslationsEditCampaigns:
      hcRouterConfigs.HC_DYNAMIC_CAMPAIGNS_EMAILS_TRANSLATIONS_EDIT,
    pushNotificationsCampaigns:
      hcRouterConfigs.HC_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS,
    pushNotificationsCreateCampaigns:
      hcRouterConfigs.HC_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_CREATE,
    pushNotificationsEditCampaigns:
      hcRouterConfigs.HC_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_EDIT,
    pushNotificationsTranslationsEditCampaigns:
      hcRouterConfigs.HC_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_TRANSLATIONS_EDIT
  },
  'top-surveys': {
    dynamicCampaigns: tsRouterConfigs.TS_DYNAMIC_CAMPAIGNS,
    emailsCampaigns: tsRouterConfigs.TS_DYNAMIC_CAMPAIGNS_EMAILS,
    emailsCreateCampaigns: tsRouterConfigs.TS_DYNAMIC_CAMPAIGNS_EMAILS_CREATE,
    emailsEditCampaigns: tsRouterConfigs.TS_DYNAMIC_CAMPAIGNS_EMAILS_EDIT,
    emailsTranslationsEditCampaigns:
      tsRouterConfigs.TS_DYNAMIC_CAMPAIGNS_EMAILS_TRANSLATIONS_EDIT,
    pushNotificationsCampaigns:
      tsRouterConfigs.TS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS,
    pushNotificationsCreateCampaigns:
      tsRouterConfigs.TS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_CREATE,
    pushNotificationsEditCampaigns:
      tsRouterConfigs.TS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_EDIT,
    pushNotificationsTranslationsEditCampaigns:
      tsRouterConfigs.TS_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_TRANSLATIONS_EDIT
  },
  'earn-star': {
    dynamicCampaigns: esRouterConfigs.ES_DYNAMIC_CAMPAIGNS,
    emailsCampaigns: esRouterConfigs.ES_DYNAMIC_CAMPAIGNS_EMAILS,
    emailsCreateCampaigns: esRouterConfigs.ES_DYNAMIC_CAMPAIGNS_EMAILS_CREATE,
    emailsEditCampaigns: esRouterConfigs.ES_DYNAMIC_CAMPAIGNS_EMAILS_EDIT,
    emailsTranslationsEditCampaigns:
      esRouterConfigs.ES_DYNAMIC_CAMPAIGNS_EMAILS_TRANSLATIONS_EDIT,
    pushNotificationsCampaigns:
      esRouterConfigs.ES_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS,
    pushNotificationsCreateCampaigns:
      esRouterConfigs.ES_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_CREATE,
    pushNotificationsEditCampaigns:
      esRouterConfigs.ES_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_EDIT,
    pushNotificationsTranslationsEditCampaigns:
      esRouterConfigs.ES_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_TRANSLATIONS_EDIT
  },

  'paid-tester': {
    dynamicCampaigns: ptRouterConfigs.PT_DYNAMIC_CAMPAIGNS,
    emailsCampaigns: ptRouterConfigs.PT_DYNAMIC_CAMPAIGNS_EMAILS,
    emailsCreateCampaigns: ptRouterConfigs.PT_DYNAMIC_CAMPAIGNS_EMAILS_CREATE,
    emailsEditCampaigns: ptRouterConfigs.PT_DYNAMIC_CAMPAIGNS_EMAILS_EDIT,
    emailsTranslationsEditCampaigns:
      ptRouterConfigs.PT_DYNAMIC_CAMPAIGNS_EMAILS_TRANSLATIONS_EDIT,
    pushNotificationsCampaigns:
      ptRouterConfigs.PT_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS,
    pushNotificationsCreateCampaigns:
      ptRouterConfigs.PT_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_CREATE,
    pushNotificationsEditCampaigns:
      ptRouterConfigs.PT_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_EDIT,
    pushNotificationsTranslationsEditCampaigns:
      ptRouterConfigs.PT_DYNAMIC_CAMPAIGNS_PUSH_NOTIFICATIONS_TRANSLATIONS_EDIT
  }
}

const getProjectRoutes = (project) => (projectRoutes[project] ? projectRoutes[project] : projectRoutes['prime-opinion'])

export default function createEmailCampaignsModule (options = {}) {
  const { initialState = {} } = options

  return {
    namespaced: initialState,
    state: {
      project: null,
      emailsCampaignStatusOptions: [
        {
          value: 1,
          text: 'Initialized'
        },
        {
          value: 2,
          text: 'Translating'
        },
        {
          value: 3,
          text: 'Translated'
        },
        {
          value: 4,
          text: 'Ready to schedule'
        },
        {
          value: 5,
          text: 'Scheduled'
        },
        {
          value: 6,
          text: 'Cancelled'
        },
        {
          value: 7,
          text: 'Scheduling'
        }
      ],
      emailsCampaignStatuses: {
        1: {
          text: 'Initialized',
          variant: 'secondary'
        },
        2: {
          text: 'Translating',
          variant: 'warning'
        },
        3: {
          text: 'Translated',
          variant: 'danger'
        },
        4: {
          text: 'Ready to schedule',
          variant: 'primary'
        },
        5: {
          text: 'Scheduled',
          variant: 'success'
        },
        6: {
          text: 'Cancelled',
          variant: 'dark'
        },
        7: {
          text: 'Scheduling',
          variant: 'info'
        }
      },
      pushNotificationsCampaignStatusOptions: [
        { value: 0, text: 'Draft' },
        { value: 1, text: 'Scheduled' },
        { value: 2, text: 'Ready to send', disabled: true },
        { value: 3, text: 'In progress', disabled: true },
        { value: 4, text: 'Completed', disabled: true },
        { value: 5, text: 'Failed', disabled: true },
        { value: 6, text: 'Cancelled', disabled: true }
      ],
      pushNotificationsCampaignStatuses: {
        0: {
          text: 'Draft',
          variant: 'secondary'
        },
        1: {
          text: 'Scheduled',
          variant: 'info'
        },
        2: {
          text: 'Ready to send',
          variant: 'warning'
        },
        3: {
          text: 'In progress',
          variant: 'primary'
        },
        4: {
          text: 'Completed',
          variant: 'success'
        },
        5: {
          text: 'Failed',
          variant: 'danger'
        },
        6: {
          text: 'Cancelled',
          variant: 'dark'
        }
      },
      availableCountries: [],
      availableLanguages: [],
      segmentFilterOptions: {
        segment_type: null, // nullable, string, fe. email or push_notifications, select where user can choose 1 option
        query_type: null, // nullable, string, fe. builder, or raw_sql, select where user can choose 1 option
        name: null, // nullable, string
        country_codes: [] // nullable, array, select where user can search by name, and select multiple options
      },
      emailsCampaignFilterOptions: {
        segment_id: null, // nullable, int, select where user can search by name
        statuses: null, // nullable, array, fe. [1, 2, 3], select where user can choose an option, 1 only
        scheduled_at_from: null, // nullable, date, datepicker
        scheduled_at_to: null, // nullable, date, datepicker
        user_target_datetime_from: null, // nullable, date, datepicker
        user_target_datetime_to: null // nullable, date, datepicker
      },
      pushNotificationsCampaignFilterOptions: {
        segment_id: null, // nullable, int, select where user can search by name
        statuses: null, // nullable, array, fe. [1, 2, 3], select where user can choose an option, 1 only
        scheduled_at_from: null, // nullable, date, datepicker
        scheduled_at_to: null, // nullable, date, datepicker
        user_target_datetime_from: null, // nullable, date, datepicker
        user_target_datetime_to: null // nullable, date, datepicker
      },
      perPage: 10,
      currentPage: 1,
      latestPage: 1,
      totalItems: 1,
      segmentsList: [],
      segmentDefaultRawSql: '',
      emailsSegmentOptions: [],
      pushNotificationsSegmentOptions: [],
      emailsCampaignsList: [],
      currentEmailsCampaignId: null,
      currentEmailsCampaignData: null,
      translationLanguage: null,
      translationData: null,
      pushNotificationsCampaignsList: [],
      currentPushNotificationsCampaignId: null,
      currentPushNotificationsCampaignData: null,
      ...initialState
    },
    getters: {
      getEmailsSegmentName: (state) => (id) => {
        const targetSegment = state.emailsSegmentOptions.find(
          (segment) => segment.value === id
        )

        return targetSegment ? targetSegment.text : ''
      },
      getPushNotificationsSegmentName: (state) => (id) => {
        const targetSegment = state.pushNotificationsSegmentOptions.find(
          (segment) => segment.value === id
        )

        return targetSegment ? targetSegment.text : ''
      },
      isSegmentsFilterActive (state) {
        if (!state.segmentFilterOptions) {
          return false
        }
        return (
          (state.segmentFilterOptions.name &&
            state.segmentFilterOptions.name.trim()) ||
          state.segmentFilterOptions.segment_type ||
          state.segmentFilterOptions.query_type ||
          (state.segmentFilterOptions.country_codes &&
            state.segmentFilterOptions.country_codes.length)
        )
      },
      dynamicCampaignsRouteName (state) {
        return getProjectRoutes(state.project).dynamicCampaigns.name
      },
      emailsCampaignsRouteName (state) {
        return getProjectRoutes(state.project).emailsCampaigns.name
      },
      emailsCreateCampaignsRouteName (state) {
        return getProjectRoutes(state.project).emailsCreateCampaigns.name
      },
      emailsEditCampaignsRouteName (state) {
        return getProjectRoutes(state.project).emailsEditCampaigns.name
      },
      emailsTranslationsEditCampaignsRouteName (state) {
        return getProjectRoutes(state.project).emailsTranslationsEditCampaigns
          .name
      },
      pushNotificationsCampaignsRouteName (state) {
        return getProjectRoutes(state.project).pushNotificationsCampaigns.name
      },
      pushNotificationsCreateCampaignsRouteName (state) {
        return getProjectRoutes(state.project).pushNotificationsCreateCampaigns
          .name
      },
      pushNotificationsEditCampaignsRouteName (state) {
        return getProjectRoutes(state.project).pushNotificationsEditCampaigns
          .name
      },
      pushNotificationsTranslationsEditCampaignsRouteName (state) {
        return getProjectRoutes(state.project)
          .pushNotificationsTranslationsEditCampaigns.name
      }
    },
    mutations: {
      SET_PROJECT (state, value) {
        state.project = value
      },
      SET_AVAILABLE_COUNTRIES (state, value) {
        state.availableCountries = value
      },
      SET_AVAILABLE_LANGUAGES (state, value) {
        state.availableLanguages = value
      },
      SET_SEGMENT_FILTER_OPTIONS (state, value) {
        state.segmentFilterOptions = value
      },
      RESET_SEGMENT_FILTER_OPTIONS (state) {
        state.segmentFilterOptions = []
      },
      SET_EMAILS_CAMPAIGN_FILTER_OPTIONS (state, value) {
        state.emailsCampaignFilterOptions = value
      },
      RESET_EMAILS_CAMPAIGN_FILTER_OPTIONS (state) {
        state.emailsCampaignFilterOptions = []
      },
      SET_PUSH_NOTIFICATIONS_CAMPAIGN_FILTER_OPTIONS (state, value) {
        state.pushNotificationsCampaignFilterOptions = value
      },
      RESET_PUSH_NOTIFICATIONS_CAMPAIGN_FILTER_OPTIONS (state) {
        state.pushNotificationsCampaignFilterOptions = []
      },
      SET_PER_PAGE (state, value) {
        state.perPage = value
      },
      SET_CURRENT_PAGE (state, value) {
        state.currentPage = value
      },
      SET_LATEST_PAGE (state, value) {
        state.latestPage = value
      },
      SET_TOTAL_ITEMS (state, value) {
        state.totalItems = value
      },
      RESET_PAGINATION (state) {
        state.perPage = 10
        state.currentPage = 1
        state.latestPage = 1
        state.totalItems = 1
      },
      SET_EMAILS_SEGMENT_OPTIONS (state, value) {
        state.emailsSegmentOptions = value
      },
      SET_PUSH_NOTIFICATIONS_SEGMENT_OPTIONS (state, value) {
        state.pushNotificationsSegmentOptions = value
      },
      SET_SEGMENTS_LIST (state, value) {
        state.segmentsList = value
      },
      REPLACE_SEGMENTS_LIST (state, value) {
        state.segmentsList.splice(value.index, 1, value.data)
      },
      REMOVE_SEGMENTS_LIST (state, value) {
        state.segmentsList.splice(value.index, 1)
      },
      ADD_SEGMENTS_LIST (state, value) {
        state.segmentsList.push(value)
        state.totalItems = state.totalItems + 1
      },
      SET_SEGMENT_DEFAULT_RAW_SQL (state, value) {
        state.segmentDefaultRawSql = value
      },
      SET_EMAILS_CAMPAIGNS_LIST (state, value) {
        state.emailsCampaignsList = value
      },
      REPLACE_EMAILS_CAMPAIGNS_LIST (state, value) {
        state.emailsCampaignsList.splice(value.index, 1, value.data)
      },
      SET_CURRENT_EMAILS_CAMPAIGN_ID (state, value) {
        state.currentEmailsCampaignId = value
      },
      SET_CURRENT_EMAILS_CAMPAIGN_DATA (state, value) {
        state.currentEmailsCampaignData = value
      },
      SET_TRANSLATION_LANGUAGE (state, value) {
        state.translationLanguage = value
      },
      SET_TRANSLATION_DATA (state, value) {
        state.translationData = value
      },
      SET_PUSH_NOTIFICATIONS_CAMPAIGNS_LIST (state, value) {
        state.pushNotificationsCampaignsList = value
      },
      REPLACE_PUSH_NOTIFICATIONS_CAMPAIGNS_LIST (state, value) {
        state.pushNotificationsCampaignsList.splice(value.index, 1, value.data)
      },
      SET_CURRENT_PUSH_NOTIFICATIONS_CAMPAIGN_ID (state, value) {
        state.currentPushNotificationsCampaignId = value
      },
      SET_CURRENT_PUSH_NOTIFICATIONS_CAMPAIGN_DATA (state, value) {
        state.currentPushNotificationsCampaignData = value
      }
    },
    actions: {
      // eslint-disable-next-line no-empty-pattern
      showErrorMessage ({}, { errors = null }) {
        if (errors && errors.response && errors.response.data) {
          this._vm.alertError(
            errors.response.data.errors || errors.response.data.message
          )
        } else {
          this._vm.alertError('Something went wrong')
        }
      },

      async getAvailableCountries ({ state, commit, dispatch }) {
        return await this._vm.$http
          .get(`/api/${state.project}/segments/countries`)
          .then((response) => {
            if (!this._vm.handleResponseError(response)) {
              const countries = response.data.map((country) => {
                return {
                  id: country.code,
                  ...country
                }
              })
              commit('SET_AVAILABLE_COUNTRIES', countries)
            }
          })
          .catch((errors) => {
            dispatch('showErrorMessage', { errors })
          })
      },

      async getAvailableLanguages ({ state, commit, dispatch }) {
        return await this._vm.$http
          .get(`/api/${state.project}/email-campaigns/languages`)
          .then((response) => {
            if (!this._vm.handleResponseError(response)) {
              const languages = response.data.map((country) => {
                return {
                  value: country.code,
                  text: country.name
                }
              })
              commit('SET_AVAILABLE_LANGUAGES', languages)
            }
          })
          .catch((errors) => {
            dispatch('showErrorMessage', { errors })
          })
      },

      async getSegmentsList ({ state, commit, dispatch }) {
        return await this._vm.$http
          .post(`/api/${state.project}/segments/list`, {
            per_page: state.perPage,
            page: state.currentPage,
            filters: state.segmentFilterOptions
          })
          .then((response) => {
            if (!this._vm.handleResponseError(response)) {
              const { data, raw_sql, per_page, page, last_page, total } =
                response.data

              commit('SET_SEGMENTS_LIST', data)
              commit('SET_SEGMENT_DEFAULT_RAW_SQL', raw_sql.email_campaigns)
              commit('SET_PER_PAGE', per_page)
              commit('SET_CURRENT_PAGE', page)
              commit('SET_LATEST_PAGE', last_page)
              commit('SET_TOTAL_ITEMS', total)
            }
          })
          .catch((errors) => {
            dispatch('showErrorMessage', { errors })
          })
      },

      async getSegmentOptions ({ state, commit, dispatch }) {
        if (
          state.emailsSegmentOptions.length ||
          state.pushNotificationsSegmentOptions.length
        ) return

        return await this._vm.$http
          .post(`/api/${state.project}/segments/list`, {
            per_page: 999,
            page: 1,
            filters: {}
          })
          .then((response) => {
            if (!this._vm.handleResponseError(response)) {
              const { data } = response.data

              const emailsSegments = data
                .filter((segment) => segment.segment_type === 'email')
                .map((segment) => {
                  return {
                    value: segment.id,
                    text: `${segment.name} - Estimate count: ${segment.estimate_count}`
                  }
                })

              commit('SET_EMAILS_SEGMENT_OPTIONS', emailsSegments)

              const pushNotificationsSegments = data
                .filter(
                  (segment) => segment.segment_type === 'push_notifications'
                )
                .map((segment) => {
                  return {
                    value: segment.id,
                    text: `${segment.name} - Estimate count: ${segment.estimate_count}`
                  }
                })

              commit(
                'SET_PUSH_NOTIFICATIONS_SEGMENT_OPTIONS',
                pushNotificationsSegments
              )
            }
          })
          .catch((errors) => {
            dispatch('showErrorMessage', { errors })
          })
      },

      async getEmailsCampaignsList ({ state, commit, dispatch }) {
        return await this._vm.$http
          .post(`/api/${state.project}/email-campaigns/list`, {
            per_page: state.perPage,
            page: state.currentPage,
            filters: state.emailsCampaignFilterOptions
          })
          .then((response) => {
            if (!this._vm.handleResponseError(response)) {
              const { data, per_page, page, last_page, total } = response.data

              commit('SET_PER_PAGE', per_page)
              commit('SET_CURRENT_PAGE', page)
              commit('SET_LATEST_PAGE', last_page)
              commit('SET_TOTAL_ITEMS', total)
              commit('SET_EMAILS_CAMPAIGNS_LIST', data)
            }
          })
          .catch((errors) => {
            dispatch('showErrorMessage', { errors })
          })
      },

      updateCurrentEmailsCampaign ({ state }, { data }) {
        const targetIndex = state.emailsCampaignsList.findIndex(
          (campaign) => campaign.id === data.id
        )

        if (targetIndex !== -1) {
          state.emailsCampaignsList.splice(targetIndex, 1, data)
        }
      },

      async getEmailsCampaignData ({ state, commit, dispatch }) {
        if (!state.currentEmailsCampaignId) return

        return await this._vm.$http
          .get(
            `/api/${state.project}/email-campaigns/${state.currentEmailsCampaignId}`
          )
          .then((response) => {
            if (!this._vm.handleResponseError(response)) {
              commit('SET_CURRENT_EMAILS_CAMPAIGN_DATA', response.data)
            }
          })
          .catch((errors) => {
            dispatch('showErrorMessage', { errors })
          })
      },

      async getPushNotificationsCampaignsList ({ state, commit, dispatch }) {
        return await this._vm.$http
          .get(`/api/${state.project}/fcm-campaigns`, {
            // per_page: state.perPage,
            // page: state.currentPage,
            // filters: state.emailsCampaignFilterOptions
          })
          .then((response) => {
            if (!this._vm.handleResponseError(response)) {
              // const { data, per_page, page, last_page, total } = response.data

              // commit('SET_PER_PAGE', per_page)
              // commit('SET_CURRENT_PAGE', page)
              // commit('SET_LATEST_PAGE', last_page)
              // commit('SET_TOTAL_ITEMS', total)
              // commit('SET_PUSH_NOTIFICATIONS_CAMPAIGNS_LIST', data)
              commit('SET_PUSH_NOTIFICATIONS_CAMPAIGNS_LIST', response.data)
            }
          })
          .catch((errors) => {
            dispatch('showErrorMessage', { errors })
          })
      },

      updateCurrentPushNotificationsCampaign ({ state }, { data }) {
        const targetIndex = state.pushNotificationsCampaignsList.findIndex(
          (campaign) => campaign.id === data.id
        )

        if (targetIndex !== -1) {
          state.pushNotificationsCampaignsList.splice(targetIndex, 1, data)
        }
      },

      async getNotificationsCampaignData ({ state, commit, dispatch }) {
        if (!state.currentPushNotificationsCampaignId) return

        return await this._vm.$http
          .get(
            `/api/${state.project}/fcm-campaigns/${state.currentPushNotificationsCampaignId}`
          )
          .then((response) => {
            if (!this._vm.handleResponseError(response)) {
              commit(
                'SET_CURRENT_PUSH_NOTIFICATIONS_CAMPAIGN_DATA',
                response.data
              )
            }
          })
          .catch((errors) => {
            dispatch('showErrorMessage', { errors })
          })
      },

      async cancelPushNotificationCampaign (
        { state, dispatch },
        { item, updateList = true }
      ) {
        try {
          this._vm.showLoading()
          await this._vm.$http.post(
            `/api/${state.project}/fcm-campaigns/${item.id}/cancel`
          )

          if (!updateList) return
          dispatch('updateCurrentPushNotificationsCampaign', {
            data: { ...item, status: 6 } // cancel status = 6
          })

          // Reload page if filter statuses is active
          if (state.pushNotificationsCampaignFilterOptions.statuses) {
            try {
              this._vm.showLoading()
              dispatch('getPushNotificationsCampaignsList')
            } finally {
              this._vm.hideLoading()
            }
          }
        } catch (errors) {
          dispatch('showErrorMessage', { errors })
        } finally {
          this._vm.hideLoading()
        }
      }
    }
  }
}
